import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { defaultContainerSize, mq } from '../../../styles/mixins';

export const Wrapper = styled.section`
  background-color: ${({ theme }) => theme.colors.light_grey};
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  ${defaultContainerSize};
  padding-top: 3.25rem;
  padding-bottom: 3.25rem;
`;

export const Title = styled.h3`
  font-weight: 400;
  font-family: ${({ theme }) => theme.font.questrial};
  font-size: 2rem;
  line-height: 2.5rem;
  color: ${({ theme }) => theme.colors.core_black};
  margin: 0 0 2rem 0;

  ${mq.medium(css`
    font-size: 3rem;
    line-height: 3.5rem;
    letter-spacing: -0.0125rem;
    margin-bottom: 5rem;
  `)};
`;

export const Benefits = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.875rem;
  row-gap: 4rem;
  justify-content: space-between;

  ${mq.mSmall(css`
    justify-content: center;
  `)};
`;

export const BenefitItem = styled.div`
  width: 8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1.5rem;

  ${mq.mSmall(css`
    width: 9.75rem;
  `)};

  ${mq.small(css`
    width: 10.625rem;
  `)};
`;

export const ItemDescription = styled.p`
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.5rem;
  font-family: ${({ theme }) => theme.font.nunito};
  color: ${({ theme }) => theme.colors.core_black};
`;

export const ItemImage = styled.div`
  width:3rem;
  height:3rem;
`;